import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FlexContainer, FlexItem } from '../../../styled/layout.styled';
import { Caption } from '../../../styled/typograpghy.styled';

const StyledTitle = styled.h4`
  color: #22096c;
  @media only screen and (max-width: 568px) {
    font-size: 20px;
    line-height: 1.4;
  }
`;

const StyledCaption = styled(Caption)`
  color: #1f0d53;
`;

const SectionTwoCard = ({ title, description, img }) => (
  <>
    <FlexContainer flexDirection="column">
      <FlexContainer alignItems="center">
        <FlexItem margin="0 16px 0 0" mobileMargin="0 16px 0 0">
          <img src={img} alt="section_image" />
        </FlexItem>
        <StyledTitle>{title}</StyledTitle>
      </FlexContainer>
      <StyledCaption>{description}</StyledCaption>
    </FlexContainer>
  </>
);

SectionTwoCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  img: PropTypes.string.isRequired,
};

export default SectionTwoCard;
